import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicIASComputer = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="IAS Computer Function"
      videos={[
        "https://www.youtube.com/embed/UwgiOkIEWHA",
        "https://www.youtube.com/embed/mVbxrQE4f90",
      ]}
      takeaways={[ 
        { text: "Remember the block diagram with register names and their functions (high probability of questions in CAT or FAT)." },
        { text: "Learn the coding part related to the IAS computer, which is similar to ALP in microprocessors (small code and architecture questions are expected)." },
      ]}
      questions={[]} // Add questions if needed
      exampleVideos={[]} // Add example question videos if needed
    />
);
}

export default ModuleSubtopicIASComputer;
